export default __webpack_public_path__ + "static/media/pic2.5759cd1f.jpg";